import { defineStore } from "pinia";
import { ref, reactive } from "vue";

export const useChecklistStore = defineStore("checklist", () => {
    const checklists = ref({});

    const state = reactive({
        isUpdating: false,
        lastError: null,
    });

    function getChecklist(taskId) {
        return checklists.value[taskId] || null;
    }

    function setChecklist(taskId, checklist) {
        checklists.value[taskId] = checklist;
    }

    function updateChecklistItems(
        taskId,
        originalItems,
        newItems = [],
        replace = false
    ) {
        if (!checklists.value[taskId]) return;

        if (replace) {
            checklists.value[taskId].items = newItems;
            return;
        }

        const items = [...originalItems];

        newItems.forEach((newItem) => {
            if (newItem.position) {
                for (let i = 0; i < items.length; i++) {
                    if (items[i].position >= newItem.position) {
                        items[i].position++;
                    }
                }
                const insertIndex = items.findIndex(
                    (item) => item.position > newItem.position
                );
                if (insertIndex === -1) {
                    items.push(newItem);
                } else {
                    items.splice(insertIndex, 0, newItem);
                }
            }
        });

        checklists.value[taskId].items = items;
    }

    function updateItemInChecklist(taskId, itemId, updates) {
        if (!checklists.value[taskId]?.items) return;
        const itemIndex = checklists.value[taskId].items.findIndex(
            (i) => i.id === itemId
        );
        if (itemIndex !== -1) {
            checklists.value[taskId].items[itemIndex] = {
                ...checklists.value[taskId].items[itemIndex],
                ...updates,
            };
        }
    }

    function setLoading(isLoading) {
        state.isUpdating = isLoading;
    }

    function setError(error) {
        state.lastError = error;
    }

    return {
        checklists,
        state,
        getChecklist,
        setChecklist,
        updateChecklistItems,
        updateItemInChecklist,
        setLoading,
        setError,
    };
});
